import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { StatusEnum } from './enum';

export interface IserverRenderList<T> {
  page: number; // 頁碼
  pageSize: number; // 每頁筆數
  totalCount: number; // 總筆數
  resultList: T[];
}

export interface IkeyValue {
  key: string;
  value: string;
}

// #region api
export interface Iresponse<T = unknown> {
  data: T;
  message: string;
  status: StatusEnum;
}

export type IdoAxiosReturn<T> = Promise<
  AxiosResponse<Iresponse<T>> | undefined
>;

/** ajax method */
export enum MethodEnum {
  get = 'get',
  delete = 'delete',
  head = 'head',
  options = 'options',
  post = 'post',
  put = 'put',
  patch = 'patch',
  purge = 'purge',
  link = 'link',
  unlink = 'unlink',
}
export interface IaxiosParam<RequestT = unknown> {
  method: MethodEnum;
  url: string;
  data?: RequestT;
  doLoading?: boolean;
  config?: AxiosRequestConfig;
}
export interface IdoAxios {
  <RequestT = unknown, ResponseT = unknown>(
    method: IaxiosParam<RequestT>['method'],
    url: IaxiosParam<RequestT>['url'],
    data?: IaxiosParam<RequestT>['data'],
    doLoading?: IaxiosParam<RequestT>['doLoading'],
    config?: IaxiosParam<RequestT>['config'],
  ): IdoAxiosReturn<ResponseT>;
}

export interface IblobAxios {
  <RequestT = unknown>(
    method: IaxiosParam<RequestT>['method'],
    url: IaxiosParam<RequestT>['url'],
    data?: IaxiosParam<RequestT>['data'],
    config?: IaxiosParam<RequestT>['config'],
  ): Promise<AxiosResponse<Blob>>;
}

export interface IblobDownload {
  (
    response: AxiosResponse<Blob>,
    // enqueueSnackbar: ProviderContext['enqueueSnackbar'],
    fileName?: string,
  ): void;
}

// #endregion api

// #region project
export interface IfileObj {
  /** 使用者是否刪除 */
  fileDeleteFlag: boolean;
  uploadFileName: string;
  uploadFileId: string;
}

export interface IdisciplinaryFileObj {
  /** 副檔名 */
  ext: string;
  /** 檔案內容 */
  file: string;
  /** 檔案id */
  id: string;
  /** 檔案名稱 */
  name: string;
  /** 檔案大小 */
  size: number;
  /** 檔案mime type */
  type: string;
  /** 檔案下載路徑 */
  url: string;
  /** 使用者是否按下刪除 */
  fileDeleteFlag: boolean;
}

// #endregion project
